import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '~/app/rootReducer';

// Base selectors
const selectTripHistoryState = (state: RootState) => state.tripHistory;

// Simple selectors
export const selectSelectedTripId = createSelector(
  selectTripHistoryState,
  (tripHistory) => tripHistory.selectedTripId
);

export const selectHoveredTripId = createSelector(
  selectTripHistoryState,
  (tripHistory) => tripHistory.hoveredTripId
);

export const selectSelectedClusterId = createSelector(
  selectTripHistoryState,
  (tripHistory) => tripHistory.selectedClusterId
);

export const selectSelectedEventId = createSelector(
  selectTripHistoryState,
  (tripHistory) => tripHistory.selectedEventId
);

export const selectHoveredEventId = createSelector(
  selectTripHistoryState,
  (tripHistory) => tripHistory.hoveredEventId
);

export const selectSelectedDate = createSelector(
  selectTripHistoryState,
  (tripHistory) => {
    // Convert ISO string back to Date if it exists
    return tripHistory.selectedDate
      ? new Date(tripHistory.selectedDate)
      : undefined;
  }
);

export const selectAssetId = createSelector(
  selectTripHistoryState,
  (tripHistory) => tripHistory.assetId
);

export const selectIsMapReady = createSelector(
  selectTripHistoryState,
  (tripHistory) => tripHistory.isMapReady
);

export const selectClusterCoordinates = createSelector(
  selectTripHistoryState,
  (tripHistory) => tripHistory.clusterCoordinates
);

export const selectHoverOnList = createSelector(
  selectTripHistoryState,
  (tripHistory) => tripHistory.hoverOnList
);

export const selectHoverEventType = createSelector(
  selectTripHistoryState,
  (tripHistory) => tripHistory.hoverEventType
);
